import { Card, CardBody, CardHeader } from "@/components/ui/Card";
import { CardTitleWithHelp } from "@/components/ui/title-help";

const GAPS = [
  {
    title: "Engineering change orders",
    hint: "ECO records live in Document Control. There is no quality-case link column, so this card cannot create or link an ECO.",
    body: "Cannot create or link an engineering change order from a quality case. Document Control already has the ECO list. A case link would need a new column, and this change does not add one.",
  },
  {
    title: "Effectiveness reviews",
    hint: "Effectiveness text is stored on the corrective action report. There is no separate effectiveness table.",
    body: "Cannot create a separate effectiveness review. Record the result on the linked corrective action when that report reaches verification.",
  },
  {
    title: "Reports and communications",
    hint: "There is no quality communications table. Case notes are the append-only thread.",
    body: "Cannot create a separate report or communication record. Use case notes for the thread, and the case traveler when you need a printed snapshot.",
  },
] as const;

export function QualityCaseRecordGapsCard(): JSX.Element {
  return (
    <>
      {GAPS.map((gap) => (
        <Card key={gap.title}>
          <CardHeader>
            <CardTitleWithHelp hoverHint={gap.hint}>{gap.title}</CardTitleWithHelp>
          </CardHeader>
          <CardBody>
            <p className="text-sm text-slate-600">{gap.body}</p>
          </CardBody>
        </Card>
      ))}
    </>
  );
}
